
import { Component, ChangeDetectionStrategy, inject, signal, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { PrescriptionService } from '../../services/prescription.service';

@Component({
  selector: 'app-verify-certificate',
  standalone: true,
  imports: [CommonModule, DatePipe], // RouterLink removed
  templateUrl: './verify-certificate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyCertificateComponent implements OnInit {
  private route: ActivatedRoute = inject(ActivatedRoute);
  private prescriptionService: PrescriptionService = inject(PrescriptionService);

  isLoading = signal(true);
  isValid = signal(false);
  errorMessage = signal<string | null>(null);
  
  // Data to display
  certData = signal<any>(null);

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.verify(id);
    } else {
      this.isLoading.set(false);
      this.errorMessage.set('ไม่พบรหัสใบรับรอง (Missing Certificate ID)');
    }
  }

  async verify(id: string) {
    try {
      const result = await this.prescriptionService.verifyPrescriptionPublic(id);
      
      if (result && result.found) {
          this.isValid.set(true);
          this.certData.set(result);
      } else {
          this.isValid.set(false);
          this.errorMessage.set(result?.message || 'ไม่พบข้อมูลใบรับรองนี้ในระบบ');
      }
    } catch (e: any) {
      this.isValid.set(false);
      this.errorMessage.set('เกิดข้อผิดพลาดในการเชื่อมต่อระบบ: ' + e.message);
    } finally {
      this.isLoading.set(false);
    }
  }
}
